import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const FriesContext = createContext();

export const FriesProvider = ({ children }) => {
  const [infoFries, setInfoFries] = useState({
    previsaoVendas: 0,
    estoque: 0,
    previsaoProducao: 0,
    custoUnitario: 0,
    receitaProduto: 0,
    pesoCaixa: 1,
    preco: 0
  });
  const [insumosFries, setInsumosFries] = useState([])
  const [stockFriesMarket, setStockFriesMarket] = useState(0)

  function getFriesStockMp() {
    const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

    if (!storagedCurrentUserGame.supermercado) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/10/${storagedCurrentUserGame?.supermercado}`)
      .then(response => {
        setStockFriesMarket(response.data ? response.data.quantidade : 0)
      })

  }

  function getFriesStock() {
    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));

    if (!storagedIndustry) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/10/${storagedIndustry?.industria}`)
      .then(response => {
        setInfoFries({
          previsaoVendas: 0,
          estoque: response.data ? response.data.quantidade : 0,
          previsaoProducao: 0,
          custoUnitario: infoFries.custo,
          receitaProduto: infoFries.receitaProduto,
          pesoCaixa: 1,
          preco: 6.80
        })
      })

  }

  useEffect(() => {
    const storagedJogo = JSON.parse(localStorage.getItem('@App:jogo'));

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarInsumos/10`)
      .then(response => {
        console.log(response)
        setInsumosFries(response.data)

      })

    axios.get("https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarTodos")
      .then(response => {
        const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
        const data = response.data[3]

        const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

        if (storagedCurrentUserGame?.supermercado) {
          //get do estoque do supermercado
          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/10/${storagedCurrentUserGame?.supermercado}`)
            .then(response => {
              setStockFriesMarket(response.data ? response.data.quantidade : 0)
              setInfoFries({
                custoUnitario: data.custo
              })
            })
          return
        }

        if (!storagedIndustry) return
        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/10/${storagedIndustry?.industria}`)
          .then(response => {
            setInfoFries({
              previsaoVendas: 0,
              estoque: response.data ? response.data.quantidade : 0,
              previsaoProducao: 0,
              custoUnitario: data.custo,
              receitaProduto: infoFries.receitaProduto,
              pesoCaixa: 1,
              preco: 6.80
            })
          })
      })

  }, []);

  return (
    <FriesContext.Provider
      value={{
        infoFries,
        setInfoFries,
        setInsumosFries,
        insumosFries,
        stockFriesMarket,
        getFriesStock,
        getFriesStockMp
      }}
    >
      {children}
    </FriesContext.Provider>
  );
};

export const useFries = () => useContext(FriesContext);
